export const iconFontAwesomeDesignDroplet = (
	<i className="fa-solid fa-droplet"></i>
);
